import { useEffect, useState } from 'react';
import axios from 'axios';

export const useContentstackAPI = (content_data, other) => {
	const [content, setContent] = useState([]);
	const [status, setStatus] = useState('idle');

	useEffect(() => {
		if (!content_data?.[0]) return;

		const fetchContent = async (stack_key, content_uid, entry_uid) => {
			const headers = {
				api_key: stack_key,
				access_token: 'csee445b90ba718c288bb56ebe',
			};

			const entries = await axios.get(`https://cdn.contentstack.io/v3/content_types/${content_uid}/entries${entry_uid ? `/${entry_uid}` : ''}?environment=production${other || ''}`, { headers });
			if (entries?.data?.entry) {
				return entries.data.entry;
			} else if (entries?.data?.entries?.[0]) {
				return entries.data.entries;
			} else {
				return { error: 'No data found' };
			}
		};

		Promise.all(content_data.map((entry) => fetchContent(entry.custom[0].api_key, entry.custom[0].content_type, entry.custom[0].entry_uid)))
			.then((response) => {
				setContent(response);
				setStatus('success');
			})
			.catch(() => setStatus('error'));
		// eslint-disable-next-line react-hooks/exhaustive-deps -- componentDidMount
	}, []);

	return { content, status };
};
